<template>
	<div class="browser-unsupported">
		<article class="content-box">
			<h1>MTG Deck Builder by Iristorm Design</h1>
			<h2>Error: Browser Unsupported</h2>
			<p>
				Sorry, but this web app can’t be displayed on the web browser you’re
				currently using, because your browser doesn’t pass the minimum technical
				requirements.
			</p>
			<p>
				Any of the
				<a href="https://browsehappy.com/" target="_blank"
					>major web browsers</a
				>
				support MTG Deck Builder. If you’re using one of them, then ensure that
				your browser is updated to its latest version, and that local storage of
				data isn’t somehow blocked.
			</p>
		</article>
	</div>
</template>
